import axios from '../../service/index'
import React, { Component } from 'react'
import { Button, Divider, Table } from 'antd'

import './zipPackage.less'
class ZipPackage extends Component {
  state = {
    columns: [{
      title: '学科',
      dataIndex: 'subjectName',
      align: 'center',
      key: 'subjectName',
    },
    {
      title: '资料包数量',
      dataIndex: 'informationPackageNum',
      align: 'center',
      key: 'informationPackageNum',
      render: (row, obj) => {
        return (
          <Button type="link" onClick={() => {this.props.history.push('/detail',{subjectId: obj.subjectId,subjectName:obj.subjectName})}}>{row}</Button>
        )
      }
    },
	{
      title: '操作',
      align: 'center',
      render: (row) => {
        return (
          <Button type="link" onClick={() => {this.props.history.push('/detail',{subjectId: row.subjectId,subjectName:row.subjectName})}}>资料包管理</Button>
        )
      }
    }],
    dataSource: [],
    total: 0,
    current: 1,
    size: 10
  }
  componentDidMount() {
    this.zipPackageList()
  }
  zipPackageList() {
    axios.get('datum/subject/datum').then(res => {
      if (res.data.code === '200') {
        this.setState({dataSource: res.data.data})
      }
    })
  }
  sizeChange = (current,size) => {
    // console.log(size)
    this.setState({size: size},() =>{
      this.InitPay()
    })
  }
  pageChange = (current) => {
    // console.log(current)
    this.setState({current: current},() =>{
      this.InitPay()
    })
  }
  InitPay() {
    console.log(this.state.current, this.state.size)
  }
  render() {
    let {dataSource, columns} = this.state
    return (
      <div className="zip-list">
        <span className="header-name">资料包管理</span>
				<Divider />
        <div>
          <Table pagination={false} rowKey={record => record.subjectId} dataSource={dataSource} columns={columns} />
          {/* <Pagination className="table-pagination" total={total} showSizeChanger defaultCurrent={current} defaultPageSize={size} showQuickJumper pageSizeOptions={['10','20','50','100']} onChange={this.pageChange} onShowSizeChange={this.sizeChange} /> */}
        </div>
      </div>
    )
  }
}
export default ZipPackage